// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Barcode: React.FC = () => {
    return <svg width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#030104" fillRule="nonzero">
            <path d="M0,0.803 L0.897,0.803 L0.897,12.47 L0,12.47 L0,0.803 Z M1.446,12.47 L1.951,12.47 L1.951,0.803 L1.446,0.803 L1.446,12.47 Z M2.315,12.47 L2.819,12.47 L2.819,0.803 L2.315,0.803 L2.315,12.47 Z M3.482,12.47 L4.586,12.47 L4.586,0.803 L3.482,0.803 L3.482,12.47 Z M5.47,12.47 L6.022,12.47 L6.022,0.803 L5.47,0.803 L5.47,12.47 Z M6.878,12.47 L9.166,12.47 L9.166,0.803 L6.878,0.803 L6.878,12.47 Z M12.84,12.47 L13.592,12.47 L13.592,0.803 L12.84,0.803 L12.84,12.47 Z M14.248,0.803 L14.248,12.47 L15.273,12.47 L15.273,0.803 L14.248,0.803 Z M10.084,12.47 L10.576,12.47 L10.576,0.803 L10.084,0.803 L10.084,12.47 Z M11.281,12.47 L11.773,12.47 L11.773,0.803 L11.281,0.803 L11.281,12.47 L11.281,12.47 Z"></path>
        </g>
    </g>
</svg>;
};

export default React.memo(Barcode);
